import React, { useState } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { Shield, Clock, CheckCircle, BarChart3, History, XCircle, Database } from 'lucide-react';
import { Button } from '../components/ui/button';
import AuditTrail from '../components/Quality/AuditTrail';
import CompletenessVerification from '../components/Quality/CompletenessVerification';
import StagingReviewDashboard from '../components/Quality/StagingReviewDashboard';
import YoYConsistency from '../components/Quality/YoYConsistency';
import ExclusionRegister from '../components/Quality/ExclusionRegister';
import FactorGovernance from '../components/Quality/FactorGovernance';

const navItems = [
  { path: '/quality/audit-trail', label: 'Audit Trail', icon: Clock },
  { path: '/quality/completeness', label: 'Completeness', icon: CheckCircle },
  { path: '/quality/staging', label: 'Staging Review', icon: BarChart3 },
  { path: '/quality/yoy', label: 'YoY Consistency', icon: History },
  { path: '/quality/exclusions', label: 'Exclusions', icon: XCircle },
  { path: '/quality/factors', label: 'Factor Governance', icon: Database },
];

const QualityHub = () => {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className='flex flex-col gap-4 p-6'>
      <div className='flex items-center gap-2'>
        <Shield size={24} strokeWidth={1.5} />
        <h1 className='text-2xl font-bold text-foreground'>Quality & Compliance</h1>
      </div>

      <div className='flex gap-2 flex-wrap border-b border-border pb-3'>
        {navItems.map(({ path, label, icon: Icon }) => {
          const active = location.pathname === path;
          return (
            <Button
              key={path}
              variant={active ? 'default' : 'ghost'}
              size='sm'
              onClick={() => history.push(path)}
            >
              <Icon size={14} strokeWidth={1.5} />
              {label}
            </Button>
          );
        })}
      </div>

      <Switch>
        <Route path='/quality/audit-trail'>
          <AuditTrail events={[]} />
        </Route>
        <Route path='/quality/completeness'>
          <CompletenessVerification />
        </Route>
        <Route path='/quality/staging'>
          <StagingReviewDashboard batches={[]} />
        </Route>
        <Route path='/quality/yoy'>
          <YoYConsistency />
        </Route>
        <Route path='/quality/exclusions'>
          <ExclusionRegister />
        </Route>
        <Route path='/quality/factors'>
          <FactorGovernance />
        </Route>
      </Switch>
    </div>
  );
};

export default QualityHub;
